<template lang="pug">
div
  div(:class="'elfsight-app-' + elfsightKey")
    .d-flex.justify-center.py-10
      v-progress-circular(:size="50", color="primary", indeterminate)
</template>

<script>
function timeoutRemove() {
  const el = document.querySelector(".eapps-link");
  if (el) el.remove();
  else setTimeout(timeoutRemove, 500);
}

export default {
  props: {
    elfsightKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    render() {
      let script = document.getElementById("elfsight-key-" + this.elfsightKey);
      if (script) script.remove();

      script = document.createElement("script");
      script.id = "elfsight-key-" + this.elfsightKey;
      script.src = "https://apps.elfsight.com/p/platform.js";

      document.head.insertAdjacentElement("beforeend", script);

      timeoutRemove();
    },
  },
  watch: {
    elfsightKey() {
      this.render();
    },
  },
  mounted() {
    if (this.elfsightKey) this.render();
  },
};
</script>
